import React from 'react'
import EditForm from '../edit-form'
import { Button } from 'react-bootstrap'
import { PenFill } from 'react-bootstrap-icons'

const LocationItem = ({
    id,
    name
}) => {
    const [ formVisible, setFormVisible ] = React.useState()
    if (formVisible) {
        return (
            <EditForm onClose={() => setFormVisible(false)} id={id} name={name} />
        )
    }
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
        >
            <div style={{ display: 'flex', flex: 1, paddingRight: '20px' }}>
                {name}
            </div>
            <div>
                <Button size="sm" variant="light" onClick={() => setFormVisible(true)}><PenFill /></Button>
            </div>
        </div>
    )
}

export default LocationItem